import React from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { RedDeleteIcon, TableEditRedIcon } from "../../../assets/images";
import {
  formatDate,
  formatTimeWithSpace,
  formateDateTime,
} from "../../../utils/commonFunctions";
import { CircularAvatar } from "../../commons";
import "./RecruitmentModule.scss";
import UpdatedByAndUpdatedAt from "../../commons/CommonUpdatedByAndUpdatedAt";

type AppProps = {
  data: any;
  header: TableHeadersType[];
  history: any;
  handleEditRecruitmentTracker?: (data: any) => void;
  handleDeleteRecruitmentData?: (data: string) => void;
  isDeleteRecruitmentTrackerPresent?: boolean;
  isEditRecruitmentTrackerPresent?: boolean;
  activeTab: string;
};
const RecruitmentTrackerTableData = ({
  data,
  header,
  history,
  handleEditRecruitmentTracker,
  handleDeleteRecruitmentData,
  isDeleteRecruitmentTrackerPresent,
  isEditRecruitmentTrackerPresent,
  activeTab,
}: AppProps) => {
  return (
    data?.length > 0 &&
    data?.map((dataItem: any) => {
      return (
        <tr>
          {header?.map((headerData: TableHeadersType) => {
            if (headerData?.value === "applicantion_date") {
              return <td>{formatDate(dataItem?.application_date)}</td>;
            } else if (headerData?.value === "name") {
              return (
                <td style={{ minWidth: "150px" }}>
                  <div
                    className="ml-2"
                    style={{
                      display: "flex",
                      justifyContent: "left",
                      alignItems: "start",
                      gap: "7px",
                      minWidth: "180px",
                    }}
                  >
                    <div>
                      <CircularAvatar
                        name={`${dataItem?.name}`}
                        image={
                          dataItem?.profile_pic &&
                          dataItem?.profile_pic?.file_url
                        }
                      />
                    </div>
                    <div>
                      <span>{dataItem?.name}</span>
                      <p
                        style={{
                          fontSize: "12px",
                          color: "#6e7491",
                          margin: "0px",
                        }}
                      >
                        {dataItem?.email}
                      </p>
                      <p style={{ fontSize: "12px", color: "#6e7491" }}>
                        {dataItem?.phone_number}
                      </p>
                    </div>
                  </div>
                </td>
              );
            } else if (headerData?.value === "years_of_experience") {
              return <td>{dataItem?.years_of_experience}</td>;

            } 
            else if (headerData?.value === "unique_id") {
              return <td>{dataItem?.unique_id}</td>;

            } 

            else if (headerData?.value === "job_position") {
              return <td>{dataItem?.job_position?.name}</td>;
            } else if (headerData?.value === "job_location") {
              return <td>{dataItem?.job_location?.name}</td>;
            } else if (headerData?.value === "notice_period") {
              return <td>{dataItem?.notice_period}</td>;
            } else if (headerData?.value === "created_finac") {
              return (
                <td>
                  <span
                    className={dataItem?.is_user_created ? "credit" : "debit"}
                  >
                    {dataItem?.is_user_created ? "Yes" : "No"}
                  </span>
                </td>
              );
            } else if (headerData?.value === "recruiter") {
              return (
                <td>
                  {dataItem?.recruiter?.first_name ? (
                    <div
                      className="ml-2"
                      style={{
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "center",
                        gap: "7px",
                        minWidth: "180px",
                      }}
                    >
                      <div>
                        <CircularAvatar
                          name={`${dataItem?.recruiter?.first_name} ${dataItem?.recruiter?.last_name}`}
                          image={
                            dataItem?.recruiter?.profile_pic &&
                            dataItem?.recruiter?.profile_pic?.file_url
                          }
                        />
                      </div>
                      <div>
                        <span>
                          {dataItem?.recruiter?.first_name}{" "}
                          {dataItem?.recruiter?.last_name}
                        </span>
                      </div>
                    </div>
                  ) : (
                    "--/--"
                  )}
                </td>
              );
            }
            else if (headerData?.value==="gender"){
              return (<td style={{ textAlign: "left", minWidth: "58px" }}>
                {dataItem?.gender ? dataItem?.gender : "NA"}
            </td>)
            }
            else if (headerData?.value === "progress") {
              return (
                <td style={{ minWidth: "220px" }}>
                  <span
                    className={
                      dataItem?.progress === "New Application" || 
                      dataItem?.progress === "Initial Screening"
                        ? "newApplication"
                        : dataItem?.progress === "Phone Screening" ||
                        dataItem?.progress === "Virtual" ||
                        dataItem?.progress === "First Interview" ||
                        dataItem?.progress === "Technical Interview" ||
                          dataItem?.progress === "Interviewing"
                        ? "phoneScreening"
                        : dataItem?.progress === "Offer Pending" || 
                        dataItem?.progress === "To Be Reviewed"
                        ? "pending"
                        : dataItem?.progress === "Offer Rejected" ||
                          dataItem?.progress === "Application Rejected" ||
                          dataItem?.progress === "Over Qualified" ||
                          dataItem?.progress === "Future Consideration"||
                          dataItem?.progress === "Over Budget" ||
                          dataItem?.progress === "Postponed"
                        ? "rejected"
                        : dataItem?.progress === "Offer Sent" ||
                          dataItem?.progress === "Offer Accepted" || 
                          dataItem?.progress === "Pay Approval" || 
                          dataItem?.progress === "Final Round" 
                        ? "sent"
                        : dataItem?.progress === "Accepted but Withdrawn" ||
                          dataItem?.progress === "Application on Hold"
                        ? "onhold"
                        : ""
                    }
                  >
                    {dataItem?.progress}
                  </span>
                </td>
              );
            } else if (headerData?.value === "updated_by") {
              return (
                <td style={{ width: "180px" }}>
                  <UpdatedByAndUpdatedAt
                    firstName={
                      dataItem?.updated_by?.first_name
                        ? dataItem?.updated_by?.first_name
                        : ""
                    }
                    lastName={dataItem?.updated_by?.last_name}
                    profilePic={dataItem?.updated_by?.profile_pic?.file_url}
                    updatedAt={
                      dataItem?.updated_at
                        ? formateDateTime(dataItem?.updated_at)
                        : ""
                    }
                  />
                </td>
              );
            } else if (headerData?.value === "Edit") {
              return (
                <td style={{ textAlign: "left", minWidth: "58px" }}>
                  {isEditRecruitmentTrackerPresent && (
                    <span
                      className="d-inline-block pointer"
                      onClick={() =>
                        handleEditRecruitmentTracker?.(dataItem._id)
                      }
                    >
                      <img src={TableEditRedIcon} alt="edit" />
                    </span>
                  )}
                  {isDeleteRecruitmentTrackerPresent &&
                    activeTab !== "offer_Accepted" && (
                      <span
                        className="d-inline-block pointer"
                        onClick={() =>
                          handleDeleteRecruitmentData?.(dataItem?._id)
                        }
                      >
                        <img src={RedDeleteIcon} alt="edit" />
                      </span>
                    )}
                </td>
              );
            }
           
          })}
        </tr>
      );
    })
  );
};

export default RecruitmentTrackerTableData;
